import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { BoatFacilitiesByBoatIdQuery } from '../gql/graphql';

const boatFacilitiesByBoatId = graphql(/* GraphQL */ `
  query boatFacilitiesByBoatId($boatId: Int!, $top: Int!) {
    boatFacilities(boatId: $boatId, top: $top) {
      name
      iconName
      facilityGroupId
    }
  }
`);

const useGetBoatFacilities = (boatId: number, top: number) => {
  const { data, isLoading } = useQuery<BoatFacilitiesByBoatIdQuery>({
    queryKey: ['boats', boatId],
    queryFn: async () =>
      graphqlRequest<BoatFacilitiesByBoatIdQuery>(boatFacilitiesByBoatId, {
        boatId,
        top,
      }), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    boatFacilities: data,
    boatFacilitiesLoading: isLoading,
  };
};

export default useGetBoatFacilities;
